import { render } from "./OidcCallbackMicrosoft.vue?vue&type=template&id=091886de"
import script from "./OidcCallbackMicrosoft.vue?vue&type=script&lang=js"
export * from "./OidcCallbackMicrosoft.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__